import { IOrderViewModel } from "../models/cashdeskModels";
import { humanizePaymentType } from "../../../common/utilities/paymentUtility";
import { AppDialog } from "../../../common/components/AppDialog/AppDialog";
import styles from "./CashdeskSuccessModal.module.scss";

interface ICashdeskSuccessModalProps {
  visible: boolean;
  order: IOrderViewModel | null;
  onNewOrder: () => void;
}

export const CashdeskSuccessModal = ({
  visible,
  order,
  onNewOrder,
}: ICashdeskSuccessModalProps) => {
  return (
    <AppDialog
      visible={visible}
      onHide={onNewOrder}
      showHeader={false}
      className={styles.dialog}
      style={{ width: "320px", maxWidth: "90vw" }}
    >
      {order && (
        <div className={styles.success}>
          <div className={styles.success_icon}>
            <span className={styles.checkmark}>✓</span>
          </div>
          <div className={styles.success_title}>Успешна поръчка!</div>
          <div className={styles.success_sub}>
            {order.displayNumber} · {humanizePaymentType(order.paymentTypeId)}
          </div>
          {order.changeAmount != null && order.changeAmount > 0 && (
            <div className={styles.success_change}>
              Ресто за връщане:{" "}
              <strong>{order.changeAmount.toFixed(2)} €</strong>
            </div>
          )}
          <button className={styles.new_order_btn} onClick={onNewOrder}>
            Нова поръчка
          </button>
        </div>
      )}
    </AppDialog>
  );
};
